import axios from 'axios';
import { setAlert } from './alert';

import {
  GET_LICENSE,
  GET_LICENSES,
  LICENSE_ERROR,
  UPDATE_LICENSE,
  CLEAR_LICENSE,
  LICENSE_DELETED,
  CHECK_LICENSE
} from './types';

export const getLicenses = () => async (dispatch) => {
  dispatch({ type: CLEAR_LICENSE });
  try {
    const res = await axios.get('/api/license');

    dispatch({
      type: GET_LICENSES,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: LICENSE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

export const getLicenseById = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/license/id/${id}`);

    dispatch({
      type: GET_LICENSE,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: LICENSE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

export const checkLicenseEntity = () => async (dispatch) => {
  try {
    const res = await axios.get('/api/license/check/entity');

    dispatch({
      type: CHECK_LICENSE,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
    }

    dispatch({
      type: LICENSE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });

    return err;
  }
};

export const createLicense = (id, formData) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const res = await axios.post(
      id ? `/api/license/id/${id}` : '/api/license',
      formData,
      config
    );

    dispatch({
      type: UPDATE_LICENSE,
      payload: res.data
    });

    dispatch(setAlert(id ? 'license updated' : 'license created', 'success'));

    return res;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
    }

    dispatch({
      type: LICENSE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });

    return err;
  }
};

// Delete user
export const deleteLicense = (id) => async (dispatch) => {
  if (
    window.confirm('Etes vous sur ? Cette opération ne peut PAS être annulée !')
  ) {
    try {
      await axios.delete(`/api/license/${id}`);

      dispatch({ type: LICENSE_DELETED });

      dispatch(
        setAlert('La licence a été effacé de manière definitive', 'danger')
      );
    } catch (err) {
      dispatch({
        type: LICENSE_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status }
      });
    }
  }
};
